import { render, staticRenderFns } from "./CompanyDialog.vue?vue&type=template&id=2018f80b"
import script from "./CompanyDialog.vue?vue&type=script&lang=js"
export * from "./CompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports